import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getRecoil } from 'recoil-nexus';

import { gameIdState } from '@/framework/game';
import { isSubscribedToGame } from '@/realtime/game-channel';

import { useReconnectGame, useExitGame, useJoinGame } from '@/use/useGame';

const Game = () => {
  const reconnectGame = useReconnectGame();
  const joinGame = useJoinGame();
  const { disconnectGame } = useExitGame();
  const { gameId: urlGameId } = useParams();

  useEffect(() => {
    if (!urlGameId) {
      return undefined;
    }

    const alreadyInThisGame =
      getRecoil(gameIdState) === urlGameId || isSubscribedToGame(urlGameId);
    if (!alreadyInThisGame) {
      if (Cookies.get(`${urlGameId}_sesh`)) {
        reconnectGame(urlGameId);
      } else {
        joinGame(urlGameId);
      }
    }

    return () => {
      disconnectGame();
    };
  }, [urlGameId]);

  return null;
};

export default Game;
